<template>
  <div>
    <div v-if="ftStage === 1">
      <DebitEnquiryForm />
    </div>
    <div v-if="ftStage === 2">
      <CreditEnquiryForm />
    </div>
    <div v-if="ftStage === 3">
      <FtFinalForm/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "../../../../utils/BaseUtils/StoreUtils";
import DebitEnquiryForm from "../../Forms/FundsTransfer/External/DebitEnquiryForm";
import CreditEnquiryForm from "../../Forms/FundsTransfer/External/CreditEnquiryForm";
import FtFinalForm from "../../Forms/FundsTransfer/External/FtFinalForm";

export default {
  name: "FundTransferExternalCard",
  components: { FtFinalForm, CreditEnquiryForm, DebitEnquiryForm },
  computed: {
    ...mapState(["ft", "loader"]),
    ftStage() {
      return StoreUtils.rootGetter(StoreUtils.getters.ft.GET_FT_STAGE);
    }
  },
  methods: {}
};
</script>

<style scoped></style>
